import * as React from 'react';

import { readStoredAccent, readStoredThemeMode, useThemeStore } from '../theme';

/**
 * Mounts once at the app root. Applies the stored/system theme (and stored
 * accent preset) on first paint and keeps `system` mode in sync with
 * OS-level scheme changes.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const setMode = useThemeStore((s) => s.setMode);
  const setAccent = useThemeStore((s) => s.setAccent);

  React.useEffect(() => {
    setMode(readStoredThemeMode());
    setAccent(readStoredAccent());

    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (useThemeStore.getState().mode === 'system') {
        setMode('system');
      }
    };
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [setMode, setAccent]);

  return <>{children}</>;
}
